import React, { FunctionComponent, memo, useMemo } from 'react';
import TechnicalSpecificationsContainer from './TechnicalSpecificationsContainer';
import StandardFeaturesContainer from './StandardFeaturesContainer';
import { Box } from '@material-ui/core';
import useVariantsSpecificationsAndFeatures from '../../../../../../gqlCommon/hooks/queries/useVariantsSpecificationsAndFeatures';
import variantDataExtractor from '../../../../../../gqlCommon/service/variantDataExtractor';
import ThemedErrorMessage from '../../../../../../common/components/presentation/error/ThemedErrorMessage';

export interface ISpecificationsContentContainer {
  selectedVariantId: string;
}

const SpecificationsContentContainer: FunctionComponent<ISpecificationsContentContainer> = memo(
  ({ selectedVariantId }) => {
    const { data, loading, error } = useVariantsSpecificationsAndFeatures();
    const variants = data?.trimLevelVariants?.variants || [];
    const selectedVariantData = useMemo(
      () => variantDataExtractor.getVariantByVariantId(variants, selectedVariantId),
      [selectedVariantId, variants],
    );
    const featureGroups = selectedVariantData?.variant?.attributes?.featureGroups;
    const specGroups = selectedVariantData?.variant?.attributes?.specGroups;

    return (
      <Box data-test={'container:specifications_and_features'}>
        {error ? (
          <ThemedErrorMessage
            error={error}
            fullPage={true}
            message={'trans__configurator__errors__general_error_message'}
          />
        ) : (
          <>
            <TechnicalSpecificationsContainer technicalSpecifications={specGroups} loading={loading} />
            <StandardFeaturesContainer standardFeatures={featureGroups} loading={loading} />
          </>
        )}
      </Box>
    );
  },
);

export default SpecificationsContentContainer;
